import { ExclamationCircleOutlined } from '@ant-design/icons';
import Image from 'next/image';
import React from 'react';

const TestFlight: React.FC = () => {
  return (
    <div className="flex flex-col items-center bg-black10 p-[16px]">
      <h1 className="font-bold text-center mt-[60px] text-[20px] md:text-[24px] md:mt-[20px] text-blue80">
        آموزش نصب اپلیکیشن تعالی مخصوص کاربران iOS
      </h1>

      <div className="bg-white border w-full mt-[28px] md:w-[540px] border-state40 rounded-[8px] py-[16px] px-[28px]">
        <div className="flex justify-between items-center">
          <div className="font-bold text-black70 text-[16px]">
            1. برنامه TestFlight را دریافت کنید
          </div>
          <Image src="/testflight.svg" width={40} height={40} alt="" />
        </div>
        <div className="mt-[12px] mb-[20px]">
          با زدن به دکمه پایین،شما به اپ استور و صفحه دانلود اپلیکیشن TestFlight وارد
          می‌شوید. دکمه Get را زده و برنامه را دانلود کنید.
        </div>

        <a
          target="_blank"
          rel="noreferrer"
          className="text-white text-[16px] bg-blue-4 hover:text-white float-left py-[2px] rounded-full px-[16px]"
          href="https://apps.apple.com/us/app/testflight/id899247664"
        >
          دانلود TestFlight
        </a>
      </div>

      <div className="bg-white border w-full mt-[28px] md:w-[540px] border-state40 rounded-[8px] py-[16px] px-[28px]">
        <div className="font-bold text-black70 text-[16px]">
          2. پس از نصب اپلیکیشن TestFlight به همین صفحه برگردید
        </div>
      </div>

      <div className="bg-white border w-full mt-[28px] md:w-[540px] border-state40 rounded-[8px] py-[16px] px-[28px]">
        <div className="flex justify-between items-center">
          <div className="font-bold text-black70 text-[16px]">
            3. برنامه تعالی را دریافت کنید
          </div>
          <Image src="/logo.webp" width={40} height={40} alt="" />
        </div>

        <div className="mt-[12px] mb-[20px]">
          با ضربه زدن به دکمه پایین، شما به اپلیکیشن ،TestFlight و صفحه دانلود اپلیکیشن
          تعالی وارد می‌شوید. دکمه Get را زده و برنامه را دانلود کنید و از آن استفاده
          کنید.
        </div>

        <a
          target="_blank"
          rel="noreferrer"
          className="text-white text-[16px] bg-blue-4 hover:text-white float-left py-[2px] rounded-full px-[16px]"
          href="https://testflight.apple.com/join/lTFeEkcb"
        >
          دانلود تعالی
        </a>
      </div>

      <div className="mt-[28px] text-black50 mb-[36px] w-full md:w-[540px] flex gap-[16px]">
        <ExclamationCircleOutlined style={{ fontSize: 24, color: '#64748b' }} />
        کاربر گرامی روش فوق به دلیل گذر از تحریم‌های آمریکا می‌باشد و برای ادامه استفاده
        از اپلیکیشن تعالی نباید اپلیکیشن TestFlight را حذف کرد
      </div>
    </div>
  );
};

export default TestFlight;
